import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Link } from "react-router-dom";

import MobileDrawer from "./mobile/MobileDrawer";
import DesktopNavigation from "./DesktopNavigation";
import { NAV_CONFIG } from "../../../constants";

const theme = createTheme({
  palette: {
    primary: {
      main: "#2C3E50",
    },
    secondary: {
      main: "#3498DB",
    },
    background: {
      default: "#F5F7FA",
    },
    text: {
      primary: "#34495E",
    },
  },
});

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  return (
    <ThemeProvider theme={theme}>
      <AppBar
        position="static"
        color="primary"
        elevation={0}
        sx={{
          backgroundColor: "background.default",
          boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.1)",
        }}
      >
        <Container
          maxWidth="xl"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 2,
          }}
        >
          <Typography
            variant="h5"
            component={Link}
            to="/"
            sx={{
              flexGrow: 1,
              fontWeight: "bold",
              color: "primary.main",
              textDecoration: "none",
              "&:hover": {
                color: "secondary.main",
              },
            }}
          >
            Dhorobha
          </Typography>

          <Box
            sx={{
              display: { md: "none", xs: "flex" },
              alignItems: "center",
            }}
          >
            <IconButton onClick={handleDrawerToggle} color="primary">
              <MenuIcon />
            </IconButton>
          </Box>
          <DesktopNavigation navLinks={NAV_CONFIG} />
          <MobileDrawer
            navItems={NAV_CONFIG}
            mobileOpen={mobileOpen}
            handleDrawerToggle={handleDrawerToggle}
          />
        </Container>
      </AppBar>
    </ThemeProvider>
  );
}
